import { ReactElement } from 'react';

import FilterService from '@philips-emr/hpms-stipulator-commons/lib/services/filter-service';
import { HpmsCustomCardEvent, HpmsCustomCardMenuRenderEvent } from '@philips-emr/hpms-stipulator-components';
import { HPMSOnCreateMenu, HPMSOnCreateOption, HPMSOnOptionClick } from '@philips-emr/hpms-stipulator-components/lib/events';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnDynamicContentRender, OnMount, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';
import { ModalProps, ModalService } from '@philips-emr/tws-core/lib/services/modal-service';

import { ConsultaTransferenciaTitularidadeAliases as Aliases } from '../codegen';

import BaseController from './BaseController';
import { getLoteStampBySituacao, LoteSituacao } from './lote/lote-utils';

enum Situacao {
  APROVADO = 1,
  REJEITADO = 2,
  PENDENTE = 3,
}

interface Data {
  dsSituacao: string;
  ieSituacao: Situacao;
  nrSeqSolic: number;
}

const OptionKey = {
  OBSERVACAO: 'observacao',
};

@Controller({ fragment: 'consulta-transferencia-titularidade' })
class ConsultaTransfTitularidadeController extends BaseController {

  @OnMount(Aliases.FILTER_CONSULTA)
  onFilterMount(event: MountEvent): void {
    FilterService.restoreFilterState(event);
  }

  @OnUnmount(Aliases.FILTER_CONSULTA)
  onUnmountFilter(event: MountEvent): void {
    FilterService.persistFilterState(event);
  }

  @OnDynamicContentRender(Aliases.RENDER_STATUS)
  onDynamicContentRenderCardLote(event: RenderEvent): void {
    const { data, render } = event;
    const { dsSituacao, ieSituacao } = data as Data;

    const situacaoMap = {
      [Situacao.APROVADO]: LoteSituacao.INTEGRADO_A_PROPOSTA,
      [Situacao.PENDENTE]: LoteSituacao.AGUARDANDO_ACAO_DO_USUARIO,
      [Situacao.REJEITADO]: LoteSituacao.REJEITADA_PELA_OPERADORA,
    };

    const content = (): ReactElement => (getLoteStampBySituacao(situacaoMap[ieSituacao], dsSituacao));

    render(content);
  }

  @HPMSOnCreateOption(Aliases.HPMS_CUSTOM_CARD)
  onCreateOption(event: HpmsCustomCardMenuRenderEvent<Record<string, Value>>): void {
    const { data, key, shouldRender } = event;
    const { ieSituacao } = data as unknown as Data;

    const show = {
      [OptionKey.OBSERVACAO]: ieSituacao == Situacao.REJEITADO,
    };

    shouldRender(show[key]);
  }

  @HPMSOnOptionClick(Aliases.HPMS_CUSTOM_CARD)
  onOptionClick(event: HpmsCustomCardEvent<Record<string, Value>>): void {
    const { key } = event;
    const { nrSeqSolic } = event.data as unknown as Data;

    const action = {
      [OptionKey.OBSERVACAO]: () => ModalService.openDefault(this.modalObservacao(nrSeqSolic)),
    };

    if (action[key]) {
      action[key]();
    }
  }

  @HPMSOnCreateMenu(Aliases.HPMS_CUSTOM_CARD)
  onCreateCardMenu(event: HpmsCustomCardMenuRenderEvent<Record<string, Value>>): void {
    const { data, shouldRender } = event;
    const { ieSituacao } = data as unknown as Data;

    if (ieSituacao != Situacao.REJEITADO) {
      shouldRender(false);
    }
  }

  private modalObservacao(nrSeqSolic: number): ModalProps {

    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();
    const modalWithFragment: ModalProps = {
      closeable: true,
      fragment: 'observacao-transf-titularidade',
      title: 'stipulator.solicitacao-rejeitada-pela-operadora',
      contextData: { nrSeqContrato, nrSeqSolic },
    };
    return modalWithFragment;
  }

}

export default ConsultaTransfTitularidadeController;
